import { render, staticRenderFns } from "./StartCourseModal.vue?vue&type=template&id=7bc95307&"
import script from "./StartCourseModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StartCourseModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports